import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';


import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio';
import { Camera } from '@ionic-native/camera';
import { AppVersion } from '@ionic-native/app-version';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import { LoginPageModule } from '../pages/login/login.module';
import { AuthProvider } from '../providers/auth/auth';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { DashboardPageModule } from '../pages/dashboard/dashboard.module';
import { UtiltiyProvider } from '../providers/utiltiy/utiltiy';
import { PrestartPageModule } from '../pages/prestart/prestart.module';
import { AddprestartPageModule } from '../pages/addprestart/addprestart.module';
import { PrestartProvider } from '../providers/prestart/prestart';
import { CrudProvider } from '../providers/crud/crud';
import { CabsandPrestartPageModule } from '../pages/cabsand-prestart/cabsand-prestart.module';
import { CabsandAddprestartPageModule } from '../pages/cabsand-addprestart/cabsand-addprestart.module';
import { KlmrFuelPageModule } from '../pages/klmr-fuel/klmr-fuel.module';
import { KlmrFuelTruckPageModule } from '../pages/klmr-fuel-truck/klmr-fuel-truck.module';
import { KlmrFuelAddPageModule } from '../pages/klmr-fuel-add/klmr-fuel-add.module';
import { KlmrFuelTruckAddPageModule } from '../pages/klmr-fuel-truck-add/klmr-fuel-truck-add.module';
import { CabsandFuelPageModule } from '../pages/cabsand-fuel/cabsand-fuel.module';
import { CabsandFuelTruckPageModule } from '../pages/cabsand-fuel-truck/cabsand-fuel-truck.module';
import { CabsandFuelAddPageModule } from '../pages/cabsand-fuel-add/cabsand-fuel-add.module';
import { CabsandFuelTruckAddPageModule } from '../pages/cabsand-fuel-truck-add/cabsand-fuel-truck-add.module';
import { JsaPageModule } from '../pages/jsa/jsa.module';
import { KlmrJsaPageModule } from '../pages/klmr-jsa/klmr-jsa.module';
import { KlmrJsaAddPageModule } from '../pages/klmr-jsa-add/klmr-jsa-add.module';
import { CabsandJsaPageModule } from '../pages/cabsand-jsa/cabsand-jsa.module';
import { CabsandJsaAddPageModule } from '../pages/cabsand-jsa-add/cabsand-jsa-add.module';
import { KlmrTimesheetCreatePageModule } from '../pages/klmr-timesheet-create/klmr-timesheet-create.module';
import { KlmrTimesheetCreateAddPageModule } from '../pages/klmr-timesheet-create-add/klmr-timesheet-create-add.module';
import { SearchPageModule } from '../pages/search/search.module';
import { CabsandTimesheetCreatePageModule } from '../pages/cabsand-timesheet-create/cabsand-timesheet-create.module';
import { CabsandTimesheetCreateAddPageModule } from '../pages/cabsand-timesheet-create-add/cabsand-timesheet-create-add.module';
import {IonMarqueeModule} from "ionic-marquee";
import { NewsPage } from '../pages/news/news';
import { KlmrNewsPage } from '../pages/klmr-news/klmr-news';
import { CabsandNewsPage } from '../pages/cabsand-news/cabsand-news';
import { KlmrTimesheetApprovalsPageModule } from '../pages/klmr-timesheet-approvals/klmr-timesheet-approvals.module';
import { KlmrTimesheetHistoryPageModule } from '../pages/klmr-timesheet-history/klmr-timesheet-history.module';
import { KlmrTimesheetPendingPageModule } from '../pages/klmr-timesheet-pending/klmr-timesheet-pending.module';
import { CabsandTimesheetApprovalsPageModule } from '../pages/cabsand-timesheet-approvals/cabsand-timesheet-approvals.module';
import { CabsandTimesheetHistoryPageModule } from '../pages/cabsand-timesheet-history/cabsand-timesheet-history.module';
import { CabsandTimesheetPendingPageModule } from '../pages/cabsand-timesheet-pending/cabsand-timesheet-pending.module';
import { KlmrJobcardPageModule } from '../pages/klmr-jobcard/klmr-jobcard.module';
import { KlmrJobcardAddPageModule } from '../pages/klmr-jobcard-add/klmr-jobcard-add.module';
import { CabsandJobcardPageModule } from '../pages/cabsand-jobcard/cabsand-jobcard.module';
import { CabsandJobcardAddPageModule } from '../pages/cabsand-jobcard-add/cabsand-jobcard-add.module';
import { KlmrPrestartJobcardPageModule } from '../pages/klmr-prestart-jobcard/klmr-prestart-jobcard.module';
import { CabsandPrestartJobcardPageModule } from '../pages/cabsand-prestart-jobcard/cabsand-prestart-jobcard.module';
import { SelectPrestartItemsPageModule } from '../pages/select-prestart-items/select-prestart-items.module';
import { CabsandFleetinfoPageModule } from '../pages/cabsand-fleetinfo/cabsand-fleetinfo.module';
import { CabsandFleetinfoAddPageModule } from '../pages/cabsand-fleetinfo-add/cabsand-fleetinfo-add.module';
import { KlmrFleetinfoPageModule } from '../pages/klmr-fleetinfo/klmr-fleetinfo.module';
import { KlmrFleetinfoAddPageModule } from '../pages/klmr-fleetinfo-add/klmr-fleetinfo-add.module';
import { SelectImageAddPageModule } from '../pages/select-image-add/select-image-add.module';
import { SelectImagePopupPageModule } from '../pages/select-image-popup/select-image-popup.module';
import { KlmrDashboardPageModule } from '../pages/klmr-dashboard/klmr-dashboard.module';
import { CabsandDashboardPageModule } from '../pages/cabsand-dashboard/cabsand-dashboard.module';
import { SafariViewController } from '@ionic-native/safari-view-controller';
import { KlmrTake_5PageModule } from '../pages/klmr-take-5/klmr-take-5.module';
import { KlmrTakeTemplatePageModule } from '../pages/klmr-take-template/klmr-take-template.module';
import { KlmrTakeTemplateAddPageModule } from '../pages/klmr-take-template-add/klmr-take-template-add.module';
import { CabsandTake_5PageModule } from '../pages/cabsand-take-5/cabsand-take-5.module';
import { CabsandTakeTemplatePageModule } from '../pages/cabsand-take-template/cabsand-take-template.module';
import { CabsandTakeTemplateAddPageModule } from '../pages/cabsand-take-template-add/cabsand-take-template-add.module';
import { SelectCategoryPageModule } from '../pages/select-category/select-category.module';
import { SelectRatingPageModule } from '../pages/select-rating/select-rating.module';
import { SelectHireMachinePageModule } from '../pages/select-hire-machine/select-hire-machine.module';



@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ListPage,
    NewsPage,
    KlmrNewsPage,
    CabsandNewsPage,
  ],
  imports: [
    BrowserModule,
    LoginPageModule,
    DashboardPageModule,
    PrestartPageModule,
    AddprestartPageModule,
    CabsandPrestartPageModule,
    CabsandAddprestartPageModule,
    KlmrFuelPageModule,
    KlmrFuelTruckPageModule,
    KlmrJsaPageModule,
    KlmrJsaAddPageModule,
    KlmrFuelAddPageModule,
    KlmrFuelTruckAddPageModule,
    CabsandFuelPageModule,
    CabsandFuelTruckPageModule,
    CabsandFuelAddPageModule,
    CabsandFuelTruckAddPageModule,
    JsaPageModule,
    CabsandJsaPageModule,
    CabsandJsaAddPageModule,
    KlmrTimesheetCreatePageModule,
    KlmrTimesheetCreateAddPageModule,
    CabsandTimesheetCreatePageModule,
    CabsandTimesheetCreateAddPageModule,
    KlmrTimesheetApprovalsPageModule,
    KlmrTimesheetHistoryPageModule,
    KlmrTimesheetPendingPageModule,
    CabsandTimesheetApprovalsPageModule,
    CabsandTimesheetHistoryPageModule,
    CabsandTimesheetPendingPageModule,
    KlmrJobcardPageModule,
    KlmrJobcardAddPageModule,
    CabsandJobcardPageModule,
    CabsandJobcardAddPageModule,
    KlmrPrestartJobcardPageModule,
    CabsandPrestartJobcardPageModule,
    CabsandFleetinfoPageModule,
    CabsandFleetinfoAddPageModule,
    KlmrFleetinfoPageModule,
    KlmrFleetinfoAddPageModule,
    KlmrDashboardPageModule,
    CabsandDashboardPageModule,
    KlmrTake_5PageModule,
    KlmrTakeTemplatePageModule,
    KlmrTakeTemplateAddPageModule,
    CabsandTake_5PageModule,
    CabsandTakeTemplatePageModule,
    CabsandTakeTemplateAddPageModule,
    HttpClientModule,
    IonMarqueeModule,
    SearchPageModule,
    SelectPrestartItemsPageModule,
    SelectImagePopupPageModule,
    SelectImageAddPageModule,
    SelectCategoryPageModule,
    SelectRatingPageModule,
    SelectHireMachinePageModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot()
  ],
  exports: [],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ListPage,
    KlmrNewsPage,
    CabsandNewsPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Camera,
    AppVersion,
    FingerprintAIO,
    InAppBrowser,
    SafariViewController,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    AuthProvider,
    UtiltiyProvider,
    PrestartProvider,
    CrudProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts